import React, { useEffect, useRef, useState } from "react";
import { FaLinkedinIn, FaPhoneAlt } from "react-icons/fa";
import ceo from "../../assets/images/shahan.avif";
import ceoAffan from "../../assets/images/affan.avif";
import banner from "../../assets/images/Office-with-equipment-and-furniture.avif";
import vision from "../../assets/images/AboutUs-OurVision.avif";
import mission from "../../assets/images/happy-small-business-owner.avif";
import map from "../../assets/images/locations-pinned-on-world-map.avif";
import { FaSearch } from "react-icons/fa";
import "../../../src/App.css";
import CustomBanner from "../../components/CustomBanner";
import { motion } from "framer-motion";
import { Head } from "vite-react-ssg";

function About() {
  const [activeCategory, setActiveCategory] = useState("General FAQs");
  const [activeIndex, setActiveIndex] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const keywords = [
    "Transparency",
    "Integrity",
    "Hard work",
    "Sustainability",
    "Agility",
    "Competence ",
    "Teamwork",
    "Growth",
    "Trust",
    "Inclusivity",
    "Craftsmanship",
    "Transparency",
    "Integrity",
    "Hard work",
    "Sustainability",
    "Agility",
    "Competence ",
    "Teamwork",
    "Growth",
    "Trust",
    "Inclusivity",
    "Craftsmanship",
  ];
  const marqueeRef = useRef(null);

  useEffect(() => {
    const marqueeElement = marqueeRef.current;
    let animationFrameId;
    let scrollPos = 0;
    const speed = 1.5;

    const animate = () => {
      scrollPos += speed;

      if (scrollPos >= marqueeElement.scrollWidth / 2) {
        scrollPos = 0;
      }

      marqueeElement.scrollLeft = scrollPos;
      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrameId);
  }, [keywords]);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <Head>
        <title>About the company and people at Apptalyst</title>
        <meta
          name="description"
          content='Apptalyst is a fusion of words "App" and "Catalyst". We’re based in Fairfax, Virginia. Meet Our Executives and see what inspires us.'
        />
        <link rel="canonical" href="https://apptalyst.com/about-us" />
      </Head>
      <CustomBanner
        bgImg={banner}
        bgPosition="bg-bottom"
        BannerImageAlt="Office with computers, equipment and furniture."
      >
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
          className="text-4xl md:text-5xl lg:text-6xl font-bold "
        >
          About Apptalyst
        </motion.h1>
      </CustomBanner>
      <div className="space-y-20 md:space-y-32 mb10 mt-20 md:mb24 md:mt-32">
        <div className="container  ">
          <div className=" md:px-10 lg:px-5  xl:px-10  space-y-14">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
              className="mb-10 text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px]  font-bold text-center text-dark font-butler"
            >
              Meet Our Executives
            </motion.h2>
            <div className="flex sm:space-x-10 lg:space-x-20  space-y-10 sm:space-y-0 flex-col justify-center items-center sm:flex-row">
              <div className="w-full  sm:w-6/12  xl:w-5/12 rounded-2xl overflow-hidden shadow-lg border h-full">
                <div className="">
                  <img src={ceo} alt="" className="h-full w-full" />
                </div>
                <div className="px-6 py-6">
                  <h3 className="text-dark font-bold text-xl lg:text-2xl  md:mb-3">
                    Shahan
                  </h3>
                  <div className="flex justify-between items-start">
                    <h4 className="text-base md:text-lg text-dark  w-8/12 md:w-8/12 lg:w-9/12">
                      Founding Partner & Chief Executive Officer
                    </h4>
                    <a
                      href="https://www.linkedin.com/in/shahansalam"
                      target="_blank"
                      rel="noopener noreferrer"
                       className="bg-gray-200 px-3.5 md:px-4 py-3.5 md:py-4 rounded text-lg  transition-all duration-300 ease-in  hover:bg-[#FFC067]"
                      aria-label="Visit Shahan Salam's LinkedIn profile"
                      title="Visit Shahan Salam's LinkedIn profile"
                    >
                       
                        <FaLinkedinIn />
                    </a>
                  </div>
                </div>
              </div>
              <div className="w-full sm:w-6/12 xl:w-5/12  rounded-2xl overflow-hidden shadow-lg border h-full">
                <div className="">
                  <img src={ceoAffan} alt="" className="h-full w-full" />
                </div>
                <div className="px-6 py-6">
                  <h3 className="text-dark font-bold text-xl lg:text-2xl  md:mb-3">
                    Affan
                  </h3>
                  <div className="flex justify-between items-start">
                    <h4 className="text-base md:text-lg text-dark  w-8/12 md:w-8/12 lg:w-9/12">
                      Founding Partner & Chief Technology Officer
                    </h4>
                    <a
                      href="https://pk.linkedin.com/in/affan-salim-51ba3524a"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-gray-200 px-3.5 md:px-4 py-3.5 md:py-4 rounded text-lg  transition-all duration-300 ease-in  hover:bg-[#FFC067]"
                      aria-label="Visit Affan Salim's LinkedIn profile"
                      title="Visit Affan Salim's LinkedIn profile"
                    >
                     
                      <FaLinkedinIn />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" bg-gray-50 py-10 ">
          <div className="  my-5 space-y-14 md:space-y-20  container ">
            <div className="flex flex-col md:flex-row rounded-xl overflow-hidden text-dark  bg-[#f3ebfa] to-100%  ">
              <div className="w-full md:w-6/12">
                <img
                  src={vision}
                  alt="A very smart and observant owl."
                  className="h-full w-full"
                  loading="lazy"
                />
              </div>
              <div className="w-full md:w-6/12 flex flex-col justify-center p-4 md:px-8 xl:px-20 ">
                <motion.h2
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.3 }}
                  className="text-2xl md:text-3xl font-bold"
                >
                  Our Vision
                </motion.h2>
                <p className="mt-5 text-base leading-[1.625rem]">
                  {" "}
                  Our ambition extends far beyond delivering technical services,
                  we aspire to be true digital partners and industry innovators.
                  Pioneered by a team of adept professionals, we’re as smart as
                  a tree full of owls. The purpose of Apptalyst is to empower
                  small businesses and enterprises alike by transforming their
                  innovative ideas into high-performing solutions. We believe
                  technology should serve as an enabler and scaled responsibly
                  to deliver lasting value and utility to users worldwide.
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row-reverse rounded-xl overflow-hidden text-dark   bg-[#f3ebfa]  ">
              <div className="w-full md:w-6/12">
                <img
                  src={mission}
                  alt="A small business owner happily displaying some useful application on their mobile phone."
                  className="h-full w-full"
                  loading="lazy"
                />
              </div>
              <div className="w-full md:w-6/12 flex flex-col justify-center p-4 md:px-8 xl:px-20">
                <motion.h2
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.3 }}
                  className="text-2xl md:text-3xl font-bold"
                >
                  Our Mission
                </motion.h2>
                <p className="mt-5 text-base leading-[1.625rem]">
                  {" "}
                  We're on a mission to explore new challenges to develop
                  disruptive solutions and prove our mettle in the landscape of
                  digital services. Our objective is to bridge the gap between
                  ideation and implementation by making cutting-edge tech
                  accessible to our clients and serving as their most trustable
                  allies in digital transformations. We define accomplishment by
                  the successful execution of our problem-solving skills and not
                  just by the count of projects we deliver.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-14 ">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className=" text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px] font-bold text-center text-dark font-butler"
          >
            Our Values & Principles
          </motion.h2>
          <div
            ref={marqueeRef}
            className="overflow-hidden whitespace-nowrap w-full bg-[#DF73FF]"
          >
            <div className="flex min-w-[800%]  py-8">
              {[...keywords, ...keywords, ...keywords].map((word, i) => (
                <div className="flex  items-center " key={i}>
                  <span className="mx-12 md:mx-20 text-xl md:text-3xl font-medium shrink-0 capitalize text-dark  ">
                    {word}
                  </span>{" "}
                  <span className="relative">
                    <span className="before:content-[''] before:block before:w-8 before:h-0.5 before:bg-dark " />
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="space-y-10  md:space-y-14">
          <div className="container">

          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className=" text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px]  font-bold text-center text-dark font-butler"
            >
            Our Locations
          </motion.h2>
            </div>
          <div className=" px-2 md:px-10 xl:px-20 bg-gray-50 py-10 md:py-20">
            <div className="relative  ">
              <img
                src={map}
                alt="World map with locations of Apptalyst pinned on it."
                className="w-full"
                loading="lazy"
              />
              <div className="absolute  h-full w-full top-0 ">
                <div className="top-[22%]  min-[400px]:top-[27%] sm:top-[29%] md:top-[29%] lg:top-[32%] 2xl:top-[35%]  min-[200px]:left-[23%]  min-[500px]:left-[24%]  sm:left-[25%] lg:left-[24%]  xl:left-[24%]  relative  inline-block">
                  <div className="flex items-baseline md:items-center space-x-2">
                    <div className="p-1 lg:p-2 bg-black w-2 h-2 lg:w-5 lg:h-5 rounded-full opacity-0 animate-fadeInOut"></div>

                    <div className="flex flex-col md:flex-row md:space-x-1 ">
                      <p className="text-[15px]  md:text-base xl:text-2xl font-bold text-dark">
                        Virginia,{" "}
                      </p>
                      <p className="text-[15px]  md:text-base xl:text-2xl font-bold text-dark">
                        US
                      </p>
                    </div>
                  </div>
                </div>
                <div className=" right-0 relative  inline-block  left-[50%] min-[320px]:left-[46%]  min-[350px]:left-[50%]  min-[400px]:left-[53%] min-[460px]:left-[58%]   min-[500px]:left-[59%] min-[550px]:left-[59%] min-[600px]:left-[61%]  min-[680px]:left-[62%] md:left-[54%] min-[800px]:left-[57%] min-[900px]:left-[59%]  lg:left-[56%]  min-[1100px]:left-[60%] xl:left-[57%]  min-[1440px]:left-[56%] 2xl:left-[57%]  min-[1600px]:left-[59%] min-[1800px]:left-[59.9%]  min-[2000px]:left-[60%]  min-[2200px]:left-[61%]  min-[2560px]:left-[61.9%]  top-[28%]    min-[300px]:top-[26%]  min-[375px]:top-[28%] min-[400px]:top-[30%] min-[460px]:top-[35%] min-[600px]:top-[36%] md:top-[34%]  lg:top-[35%] min-[2000px]:top-[37%] min-[2200px]:top-[38%] min-[2560px]:top-[38%]">
                  <div className="flex items-baseline md:items-center space-x-2">
                    <div className="p-1 lg:p-2 bg-black w-2 h-2 lg:w-5 lg:h-5 rounded-full opacity-0 animate-fadeInOutDelay"></div>
                    <div className="flex flex-col md:flex-row md:space-x-1 ">
                      <p className="text-[15px]  md:text-base xl:text-2xl font-bold text-dark">
                        Karachi,{" "}
                      </p>
                      <p className="text-[15px]  md:text-base xl:text-2xl font-bold text-dark">
                        {" "}
                        PK
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default About;
